export default "__VITE_ASSET__DUMfyT$e__"